export default __webpack_public_path__ + "static/media/assembly_4.e3c6ad9f.webp";